import {customThemeConstants} from '@hconnect/uikit/src/lib2'
import {MyLocation} from '@mui/icons-material'
import {Chip, Typography, alpha, useTheme} from '@mui/material'

import {SlaTableDataItemRow} from '../../types'

export type SlaKpiTabsTargetColumnChipProps = Pick<SlaTableDataItemRow, 'target' | 'unit'>

export const SlaKpiTabsTargetColumnChip = ({target, unit}: SlaKpiTabsTargetColumnChipProps) => {
  const theme = useTheme()
  const isDark = theme.palette.mode === 'dark'
  const chipBackground = isDark
    ? alpha(theme.palette.info.main, 0.15)
    : customThemeConstants().palette.semanticInfoFaded10
  const chipBorderColor = isDark
    ? alpha(theme.palette.info.main, 0.4)
    : customThemeConstants().palette.semanticInfoFaded20

  return (
    <Chip
      label={
        <Typography
          variant="subtitle1"
          component="div"
          sx={{
            color: theme.palette.primary.light,
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflowWrap: 'break-word'
          }}
        >{`${target ?? ''} ${unit ?? ''}`}</Typography>
      }
      icon={<MyLocation color="primary" sx={{fontSize: theme.spacing(2)}} />}
      sx={{
        backgroundColor: chipBackground,
        border: `1px solid ${chipBorderColor}`,
        height: 'auto',
        minHeight: theme.spacing(4),
        '& .MuiChip-label': {
          whiteSpace: 'normal',
          overflow: 'visible'
        },
        '& .MuiChip-icon': {
          color: theme.palette.primary.light,
          marginLeft: theme.spacing(1)
        },
        '&:hover': {
          backgroundColor: chipBackground
        }
      }}
    />
  )
}
